import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { futuresChangeHistoryApiConfig } from './futuresChangeHistory/constants'
import { fetchApiData as fetchFuturesChangeHistoryApiData } from './futuresChangeHistory/fetchApiData'
import { fetchSubTypes as fetchFuturesChangeHistorySubTypes } from './futuresChangeHistory/fetchSubTypes'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import { fetchApiData as fetchSpotTradeHistoryApiData } from './spotTradeHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'

export const gateApiConfigs = {
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [futuresChangeHistoryApiConfig.type]: futuresChangeHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type GateApiType = keyof typeof gateApiConfigs

export const gateApiTypes = Object.keys(gateApiConfigs) as GateApiType[]

export const fetchGateApiDataFuncs = {
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [futuresChangeHistoryApiConfig.type]: fetchFuturesChangeHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchGateSubTypesFuncs = {
  [depositHistoryApiConfig.type]: undefined,
  [futuresChangeHistoryApiConfig.type]: fetchFuturesChangeHistorySubTypes,
  [spotTradeHistoryApiConfig.type]: undefined,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentGateAssets } from './getCurrentAsset'
